module.exports = __webpack_public_path__ + "img/2_268.1c076b1d.png";